import classes from './StatusLabel.module.scss';

export const StatusLabel = ({ variant }) => {
  switch (variant) {
    case 'pending':
      return (
        <span className={`${classes.root} ${classes.pending}`}>In process</span>
      );

    case 'failed':
      return (
        <span className={`${classes.root} ${classes.failed}`}>Failed</span>
      );

    default:
      return null;
  }
};
